import axios from "axios";

const Api = axios.create({
    baseURL: 'https://discos.com.br/api/'
    //crossdomain: true,
    //headers: { 'Access-Control-Allow-Origin':'*' }
})

export default Api;